<template>
  <div style="padding: 5px 10px;">
    <v-card>
      <v-container>
        <table class="food-result">
          <tr>
            <td class="name">
              <!-- <p
                v-if="data.FoodVegan"
                :style="{ 'color': ColorContent,
                  'font-size': `${FontSizeContent}px`,
                  'font-family': FontContent, 
                }"
              >
                <v-tooltip v-model="showLeaf" top>
                  <template>
                    
                  </template>
                  <span>{{$t('food.vegan')}}</span>
                </v-tooltip>
                <v-tooltip v-model="showPromotion" top>
                  <template >
                    
                  </template>
                  <span>{{$t('food.vegetarian')}}</span>
                </v-tooltip>
                
              </p> -->
              <v-tooltip v-model="showLeaf" top>
                <template>
                  
                </template>
                <span>{{$t('product.promotion')}}</span>
              </v-tooltip>
              <v-tooltip v-model="showPromotion" top>
                <template >
                  
                </template>
                <span>{{$t('product.promotion')}}</span>
              </v-tooltip>
              <p
                :style="{ 'color': foodDrinkTextColor,
                  'font-size': `${FontSizeContent}px`,
                  'font-family': FontContent, 
                }"
                style="margin-bottom: 5px;"
              >
                <v-icon v-if="data && data.ProductPromotion" style="color: #F2C96C;" @click="showPromotion=!showPromotion">mdi-decagram</v-icon>{{name}}
              </p>
              <!-- <p
                v-else
                :style="{ 'color': ColorContent,
                  'font-size': `${FontSizeContent}px`,
                  'font-family': FontContent, 
                }"
              >
                {{name}}
                
              </p> -->
              <p
                :style="{ 'color': ColorContent,
                  'font-size': `${(FontSizeContent - 5)}px`,
                  'font-family': FontContent, 
                }"
              >
                {{ingredients}}
              </p>
              <!--p
                  v-if="note && note.length > 0" 
                  style="line-height: 1;margin-top:-10px;"
                  :style="{ 'color': ColorContent,
                    'font-size': `${(FontSizeContent - 5)}px`,
                    'font-family': FontContent, 
                  }"
                >
                  {{note}}
                </p-->
            </td>
            <td class="price">
              <p
                :style="{ 'color': ColorContent,
                  'font-size': `${FontSizeContent}px`,
                  'font-family': FontContent, 
                }"
              >
                {{data.ProductPrice}}
              </p>                
              <p
                  v-if="note && note.length > 0" 
                  style="line-height: 1;margin-top:-10px;"
                  :style="{ 'color': ColorContent,
                    'font-size': `${(FontSizeContent - 5)}px`,
                    'font-family': FontContent, 
                  }"
                >
                  {{note}}
                </p>
 
              <v-layout wrap :class="`justify-end`">
                <v-flex
                  v-if="data.ProductImage"
                  v-bind="{ [`xs12`]: true }"
                  :style="{ 'width' : `75px`}"
                >
                  <image-modal :data="data" :locale="locale" />
                </v-flex>
              </v-layout>
            </td>
          </tr>
        </table>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import ImageModal from './Image'
  export default {
    components: {
      ImageModal
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      showLeaf: false,
      showPromotion: false
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      name () {
        return this.data.ProductName ? utils.getTranslation (this.data.ProductName, this.locale) : ''
      },
      note () {
        return this.data.ProductNote ? utils.getTranslation (this.data.ProductNote, this.locale) : ''
      },
      ingredients () {
        return this.data.ProductDescription ? utils.getTranslation (this.data.ProductDescription, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      foodDrinkTextColor () {
        return this.$store.state.app.foodDrinkTextColor && this.$store.state.app.foodDrinkTextColor !== '' ? this.$store.state.app.foodDrinkTextColor : this.ColorContent
      },
    },
  }
</script>
<style scoped>
  .food-result {
    width: 100%;
  }
  .food-result .name {
    width: auto;
  }
  .food-result .price {
    width: 1%;
    white-space: nowrap;
    text-align: right;
    vertical-align: top;
  }
</style>
